import React, { Component } from 'react';
import PageHeader from 'components/enterprise/PageHeader';
import { routesHelpDeskAdmin } from 'routes/Routes';
import _validator from 'modules/validator';
import _AdminService from '../../modules/AdminService';
import _HelpDeskAdminServices from '../../modules/HelpDeskAdminService';
import { Button } from 'antd';
import _notification from 'modules/notification';
import {
    Modal,
    Tag,
    Input,
    Pagination
} from 'antd';
import moment from 'moment';
import CandidateListFromDB from './CandidateListFromDB_new';
import ConfirmPopup from '../popup/ConfirmPopup';
import _utils from '../../modules/Utils';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';
import EmptyState from 'components/enterprise/EmptyState';

const { Search } = Input;


class CandidatesListInHelpDesk extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: { pageSize: 5, current: 1, total: 0 },
            highlightedRowID: 0,
            data: [],
            category: [],
            degree: [],
            rowData: {},
            loading: false,
            showModel: true,
            showMessageBox: false,
            categoryError: "",
            degreeError: "",
            totalRowCount: 0,
            showCandidateReview: false,
            selectedRowKeys: [],
            searchTerm: "",
            postList: [],
            approvePopup: false,
            rejectPopup: false,
            filteredTransactionsList: [],
            filteredCandidatesDBList: [],
            showApproveButton: false,
            transactionListCheckbox: false,
            studentListCheckbox: false,
        };
    }

    getAllCandidates = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let candidateList = await _HelpDeskAdminServices.GetAllCandidatesForHelpDesk(this.state.pagination.current, this.state.pagination.pageSize, this.state.searchTerm);
                    // let candidateList = await _HelpDeskAdminServices.GetAllCandidatesFromDB(this.state.pagination.current, this.state.pagination.pageSize, this.state.searchTerm);

                    let searchedData = candidateList.data;

                    this.setState({
                        ...this.state,
                        data: searchedData.List,
                        pagination: { ...this.state.pagination, total: searchedData.TotalRecords },
                        category: this.state.data ? [...new Set(searchedData.List.map(item => item.Category ? item.Category : "A"))] : [],
                        totalRowCount: searchedData.TotalRecords,
                        loading: false,
                        selectedRowKeys: [],
                        transactionListCheckbox: false,
                        studentListCheckbox: false,
                        showApproveButton: false
                    });

                } catch (e) {
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    search = async () => {
        console.log("searchFromTransactionList++")
        let stateSearch = this.state.searchTerm;

        if (stateSearch != "") {
            try {
                this.setState({ loading: true }, async () => {
                    try {
                        let candidateList = await _HelpDeskAdminServices.GetAllCandidatesForHelpDesk(this.state.pagination.current, this.state.pagination.pageSize, this.state.searchTerm);
                        // let candidateList = await _HelpDeskAdminServices.GetAllCandidatesFromDB(this.state.pagination.current, this.state.pagination.pageSize, this.state.searchTerm);

                        let searchedData = candidateList.data;

                        this.setState({
                            ...this.state,
                            data: searchedData.List,
                            pagination: { ...this.state.pagination, total: searchedData.TotalRecords },
                            category: this.state.data ? [...new Set(searchedData.List.map(item => item.Category ? item.Category : "A"))] : [],
                            totalRowCount: searchedData.TotalRecords,
                            loading: false,
                            selectedRowKeys: [],
                            approvePopup: false,
                            rejectPopup: false,
                            transactionListCheckbox: false,
                            studentListCheckbox: false,
                            showApproveButton: false
                        });

                    } catch (e) {
                        this.setState({ loading: false });
                        console.log('Error: ', e);
                    }
                });
            } catch (e) { }
        }
    }

    onBulkApproveReject = async (flag) => {
        console.log("A", this.state.transactionListCheckbox)
        console.log("B", this.state.studentListCheckbox)
        try {

            this.setState({ loading: true }, async () => {
                try {

                    // const params = {
                    //     ApplicationIds: this.state.selectedRowKeys,
                    //     IsApprovedRejectedStatus: flag == 1 ? true : false
                    // }

                    if (this.state.filteredTransactionsList && this.state.filteredTransactionsList.length == 1) {
                        let filteredData = this.state.filteredTransactionsList && this.state.filteredTransactionsList[0];
                        const params = {
                            Id: filteredData.Id,
                            BankId: filteredData.BankId,
                            BankName: filteredData.BankName,
                            TransactionId: filteredData.TransactionId,
                            StudentId: filteredData.StudentId,
                            ApplicationId: filteredData.ApplicationId,
                            ActualTotalAmount: filteredData.ActualTotalAmount,
                            TotalCommition: filteredData.TotalCommition,
                            ServiceTax: filteredData.ServiceTax,
                            NetAmount: filteredData.NetAmount,
                            TransactionDate: filteredData.TransactionDate,
                            TransactionTime: filteredData.TransactionTime,
                            PaymentDate: filteredData.PaymentDate,
                            ITC: filteredData.ITC,
                            MobileNumber: filteredData.MobileNumber,
                            Email: filteredData.Email,
                            Status: filteredData.Status,
                            DBStatus: flag == 1 ? "Approve" : "Reject",
                            CreatedBy: filteredData.CreatedBy,
                            CreatedDate: filteredData.CreatedDate,
                            RejectionComment: filteredData.RejectionComment,
                            TransactionDateTime: filteredData.TransactionDateTime,
                            TransactionRefNumber: filteredData.TransactionRefNumber,
                            MerchantTransactionID: filteredData.MerchantTransactionID,
                            CancelReason: filteredData.CancelReason,
                            CustomerName: filteredData.CustomerName,
                            ErrorMessage: filteredData.ErrorMessage
                        }

                        const response = await _HelpDeskAdminServices.UpdateStudentApprovalRejectStatus(params);

                        if (response.status == 200) {
                            _notification.showMessage('success', `Candidate ${flag == 1 ? "Approved" : "Rejected"} successfully.`);
                            this.setState({
                                post: "",
                                postError: "",
                                showModel: false,
                                loading: false,
                                highlightedRowID: params.Id,
                                approvePopup: false,
                                rejectPopup: false,
                                selectedRowKeys: []
                            });
                            this.search();
                        }
                        else {
                            _notification.showMessage('error', response.data.message);
                            this.setState({ loading: false, approvePopup: false, rejectPopup: false, selectedRowKeys: [] })
                        }
                    }
                } catch (e) {
                    this.setState({ loading: false, approvePopup: false, rejectPopup: false, selectedRowKeys: [] })
                    console.log('Error: ', e);
                }
            });
        } catch (e) { this.setState({ loading: false, approvePopup: false, rejectPopup: false, selectedRowKeys: [] }) }
    }

    onSearch = (value) => {
        console.log("HelpOnSearch")
        this.setState({ searchTerm: value, pagination: { ...this.state.pagination, current: 1 } });
        this.search();
    }

    onSearchTextChange = ({ target: { name, value } }) => {
        this.setState({
            ...this.state,
            searchTerm: value
        });
    }

    onPageChange = (pageNumber) => {
        this.setState({ pagination: { ...this.state.pagination, current: pageNumber }, });
        this.search();
    }

    onShowSizeChange = (current, pageSize) => {
        this.setState({ pagination: { ...this.state.pagination, current: 1, pageSize: pageSize }, });
        this.search();
    };

    showHideApproveBtn = () => {
        console.log("showHideFunction")
        if (this.state.filteredTransactionsList &&
            this.state.filteredTransactionsList.length == 1 &&
            this.state.filteredCandidatesDBList &&
            this.state.filteredCandidatesDBList.length == 1
        ) {
            let transactionList = this.state.filteredTransactionsList && this.state.filteredTransactionsList[0];
            let candidateList = this.state.filteredCandidatesDBList && this.state.filteredCandidatesDBList[0];

            if (transactionList.ApplicationId == candidateList.Application_Id &&
                (candidateList.Challan_Transaction_Id == null || candidateList.Challan_Transaction_Id == "") &&
                candidateList.Is_Submitted == false) {
                this.setState({ showApproveButton: true })
            }
            // else {
            //     _notification.showMessage('error','Transaction List data and Registered Candidates List data not matching');
            // }
        }
    };

    onHtmlSelectRow = studentID => {
        let dataList = this.state.data;
        let filteredList = dataList.filter((value) => value.Id == studentID)
        this.setState({ filteredTransactionsList: filteredList })

        let tempKeys = this.state.selectedRowKeys;

        if (tempKeys.includes(studentID)) {
            this.setState({ selectedRowKeys: tempKeys.filter((value) => value != studentID), transactionListCheckbox: false, showApproveButton: false });
        }
        else {
            tempKeys.push(studentID);
            this.setState({ selectedRowKeys: tempKeys, transactionListCheckbox: true })
        }
    }

    handleCallback = (childData, checkboxStatus, showApproveButtonStatus) => {
        this.setState({ filteredCandidatesDBList: childData, studentListCheckbox: checkboxStatus, showApproveButton: showApproveButtonStatus });
    };

    parentSearchCallBack = () => {
        this.setState({ selectedRowKeys: [], transactionListCheckbox: false, studentListCheckbox: false, showApproveButton: false });
    };

    parentDataClearCallBack = () => {
        this.setState({ showApproveButton: false, studentListCheckbox: false });
    };

    componentDidUpdate(prevProps, prevState) {
        const { studentListCheckbox, transactionListCheckbox } = this.state;
        console.log("TransactionCheckbox", this.state.transactionListCheckbox)
        console.log("studentListCheckbox", this.state.studentListCheckbox)
        // Check if the relevant state variables have changed
        if (
            (prevState.studentListCheckbox !== studentListCheckbox ||
                prevState.transactionListCheckbox !== transactionListCheckbox) &&
            studentListCheckbox &&
            transactionListCheckbox
        ) {
            this.showHideApproveBtn();
        }

        if (prevState.searchTerm !== '' && this.state.searchTerm === '') {
            this.handleClear();
        }
    }

    handleClear = () => {
        console.log('handleClear()');
        this.setState({
            searchTerm: "",
            data: [],
            searchTerm: "",
            data: [],
            transactionListCheckbox: false,
            showApproveButton: false,
            selectedRowKeys: []
        });
    };

    render() {
        if (this.state.loading)
            return <LoadingSpinner />

        return ( <>

            <PageHeader
                title="Candidates List"
                subtitle="Online Transactions Data"
                breadcrumbItems={[{ label: 'Upload Transactions Data', path: routesHelpDeskAdmin.uploadTransactionsData.path }, { label: 'Candidates List' }]}
            />
            <div className="pb-4 admin-custom-table">
                <div className="ent-panel pb-3 px-1">
                    <div className="search-wrap ">
                        <Search
                            placeholder="Search Application ID, Email, Mobile No."
                            // allowClear
                            onSearch={this.onSearch}
                            value={this.state.searchTerm}
                            onChange={this.onSearchTextChange}
                            style={{
                                width: 460,
                                paddingLeft: '7px'
                            }}
                        />

                        {(this.state.selectedRowKeys.length && this.state.showApproveButton == true) ?
                            <Button 
                            id="btnApprove"
                            value="Approve"
                            size='small'
                            onClick={() => this.setState({ approvePopup: true })}
                            className="button-global button-primary ml-3 mr-2 mid autoHeight" >Approve Selected</Button>  : <></>}
                        
                        {(this.state.selectedRowKeys.length) ?
                            <Button 
                            id="btnReject" color="red"
                            value="Reject"
                            size='small'
                            onClick={() => this.setState({ rejectPopup: true })}
                            className="button-global button-border removebutton mid ml-2 autoHeight" >Reject Selected</Button> : <></>} 

                    </div>
                </div>

                
                <div className="custom-table-wrap  admin-table table-striped-rows">
                    <div className=" analysisWrap ant-table-small" >
                        <div className="ant-table-content">
                            <div className="ant-table-body">
                                <table className='customTable table-striped-rows whiteBg' id="myTable">
                                    <thead className="ant-table-thead"> 
                                        <tr className='stickyDiv'>
                                        <th className='h40'></th>
                                        <th>Application ID</th>
                                        <th>Candidate ID</th>
                                        <th>Mobile No.</th>
                                        <th>Email</th>
                                        <th>Transaction ID</th>
                                        <th>Actual Amount</th>
                                        <th>Transaction Ref. No.</th>
                                        <th>Trans. Date & Time</th>
                                        <th>Status</th>
                                        <th>DB Status</th>
                                        </tr>
                                    </thead>
                                    <tbody  className='ant-table-tbody '>
                                        {this.state.data.map((item, index) => (

                                            <tr data-index={index} key={item.Id}>

                                                <td>
                                                    <input
                                                        disabled={this.state.selectedRowKeys && this.state.selectedRowKeys.length >= 1 && !this.state.selectedRowKeys.includes(item.Id) ? true : false}
                                                        type="checkbox"
                                                        className='customTableCellCheckbox'
                                                        onClick={(enent) => this.onHtmlSelectRow(item.Id)}
                                                        checked={this.state.selectedRowKeys.includes(item.Id)}
                                                    />
                                                </td>
                                                <td>{item.ApplicationId}</td>
                                                <td>{item.StudentId}</td>
                                                <td>{item.MobileNumber}</td>
                                                <td>{item.Email}</td>
                                                <td style={{ lineHeight: '15px' }}>{item.TransactionId}</td>
                                                <td>{item.ActualTotalAmount}</td>
                                                <td>{item.TransactionRefNumber}</td>
                                                <td>{_utils.formatDateAndTime(item.TransactionDateTime)}</td>
                                                <td>{item.Status}</td>
                                                <td>{item.DBStatus}</td>

                                            </tr>
                                            ))}
                                    </tbody>
                                </table>
                                {!this.state.data.length ?
                                    <EmptyState icon="inbox" title="No Records Found" description="No records match the current search or filter criteria." />
                                    : ""}
                            </div>
                            <div className="ant-table-footer ">

                                    <div className="d-flex align-items-center justify-content-end">
                                        {this.state.selectedRowKeys.length ?
                                        <label style={{  marginRight: '20px', color: 'darkgreen' }}>Selected Records: {this.state.selectedRowKeys.length}</label>
                                        : <></>}
                                        <label style={{  marginRight: '20px' }}>Total Records: {this.state.totalRowCount}</label>        
                                    </div> 
                                
                            </div>
                        
                        </div>
                    </div>
                    {this.state.data.length ?
                        <>
                        <Pagination
                            showSizeChanger
                            pageSizeOptions={['5', '200', '300', '500', '1000']}
                            onShowSizeChange={this.onShowSizeChange}
                            onChange={this.onPageChange}
                            defaultCurrent={this.state.pagination.current}
                            total={this.state.pagination.total}
                            pageSize={this.state.pagination.pageSize}
                            className=" ant-table-pagination mini"
                        />  
                    </>
                        : ""}
                        
                </div>     
                                
                <Modal
                    centered={true}
                    width={400}
                    className="modelPopAnt admin-popup"
                    visible={this.state.approvePopup}
                    onCancel={() => this.setState({ approvePopup: false })}
                    footer={false}
                >
                    <ConfirmPopup
                        onCancel={() => this.setState({ approvePopup: false })}
                        onOk={() => this.onBulkApproveReject(1)}
                        // popupData={this.state.rowData}
                        message="Are you sure, you want to Approve this Candidate?"
                    />
                </Modal>

                <Modal
                    centered={true}
                    width={400}
                    className="modelPopAnt admin-popup"
                    visible={this.state.rejectPopup}
                    onCancel={() => this.setState({ rejectPopup: false })}
                    footer={false}
                >
                    <ConfirmPopup
                        onCancel={() => this.setState({ rejectPopup: false })}
                        onOk={() => this.onBulkApproveReject(2)}
                        // popupData={this.state.rowData}
                        message="Are you sure, you want to Reject this Candidate?"
                    />
                </Modal>
            </div>



            <div className="analysisWrap pt-3 pb-3">
                <CandidateListFromDB
                    parentCallback={this.handleCallback}
                    parentSearchCallBack={this.parentSearchCallBack}
                    parentDataClearCallBack={this.parentDataClearCallBack}
                />
            </div>

            </>
        )
    };
}

export default CandidatesListInHelpDesk;